// Feb 2026 production migration — complete list of 74 reference routes
// delivered in Fundle_Final_Website.zip and now served by <SiteMirror>.
// Order mirrors page-manifest.json. These are the routes that must render
// the pixel-faithful static HTML coming from /public/site-mirror/<path>/index.html.
// Admin / API / legacy routes are NOT in this list — they still render React.

export const MIRROR_ROUTES = [
  '/',
  '/retail-ai/loyalty-clm',
  '/retail-ai/campaign-management',
  '/retail-ai/lead-management',
  '/retail-ai/marketplace-automation',
  '/retail-ai/mbo-automation',
  '/retail-ai/ecommerce',
  '/retail-ai/social-management',
  '/retail-ai/seo',
  '/retail-ai/media-studio',
  '/retail-ai/intelligence',
  '/mall-ai/adsr',
  '/mall-ai/loyalty',
  '/mall-ai/concierge',
  '/mall-ai/advertising',
  '/mall-ai/intelligence',
  '/mall-ai/social-management',
  '/mall-ai/proptech',
  '/mall-ai/commerce',
  '/retail-ai/enterprise-agent',
  '/retail-ai',
  '/mall-ai',
  '/fundle-brain',
  '/platform',
  '/enterprise-ai-agents',
  '/stories/customer-reactivation',
  '/stories/marketplace-leakage',
  '/stories/mbo-sales-visibility',
  '/stories/mall-morning-brief',
  '/stories',
  '/customers',
  '/industries/fashion-apparel',
  '/industries/beauty-personal-care',
  '/industries/footwear',
  '/industries/food-beverage',
  '/industries/home-living',
  '/industries/electronics',
  '/industries/shopping-malls',
  '/industries/d2c-omnichannel',
  '/industries',
  '/resources/design-retail-loyalty-programme',
  '/resources/measure-campaign-incrementality',
  '/resources/mall-adsr-reporting',
  '/resources/marketplace-settlement-reconciliation',
  '/resources/mbo-secondary-sales-intelligence',
  '/resources/first-party-retail-data',
  '/resources',
  '/about',
  '/integrations',
  '/security',
  '/responsible-ai',
  '/contact',
  '/ai-roadmap',
  '/roi-calculator',
  '/privacy-policy',
  '/terms-of-service',
  '/company/careers',
  '/company/partners',
  '/news',
  '/awards-press',
  '/releases',
  '/products/consentfirst',
  '/downloads',
  '/company/management',
  '/company/ics-group',
  '/investors',
  '/company/leadership/vineet-narang',
  '/company/leadership/abhinav-khanna',
  '/company/leadership/deepak-tyagi',
  '/company/leadership/anmol-berry',
  '/videos',
  '/insights',
  '/sitemap',
];

// Set-like helper used by SiteChrome / MarketingPopups to hide the React
// nav/footer + marketing popups whenever the mirror is driving the page.
export const MIRROR_ROUTES_SET = new Set(MIRROR_ROUTES);

export const isMirrorRoute = (pathname) => {
  if (!pathname) return false;
  // Normalise trailing slash
  const p = pathname.length > 1 && pathname.endsWith('/')
    ? pathname.slice(0, -1)
    : pathname;
  return MIRROR_ROUTES_SET.has(p);
};
